import { createApiHandler } from './handler';

const branches = {
  apiClient: null,
  path: '/admin/branches',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async getAll() {
    try {
      const response = await this.apiClient.get(this.path);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default branches;
